if (!customElements.get('add-on-card')) {
  customElements.define(
    'add-on-card',
    class AddOnCard extends HTMLElement {
      #unsubscribe = null;

      connectedCallback() {
        this.#unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.#onCartUpdate);
      }

      disconnectedCallback() {
        this.#unsubscribe?.();
        this.#unsubscribe = null;
      }

      #onCartUpdate = (event) => {
        if (!event || String(event.productVariantId) !== this.dataset.variantId) return;
        this.#setAddedState();
      };

      #setAddedState() {
        const button = this.querySelector('.add-on-card__button');
        if (!button) return;

        button.classList.add('add-on-card__button--added');
        button.disabled = true;
      }
    }
  );
}
